<div
  class="toast-host pointer-events-none fixed inset-x-0 top-0 z-[100] flex flex-col items-center gap-2 px-3 pt-[max(0.75rem,env(safe-area-inset-top))] sm:items-end sm:px-4 sm:pt-4"
  aria-live="polite"
  aria-relevant="additions removals"
>
  @for (toast of toasts(); track trackById($index, toast)) {
  <article
    class="toast-host__item pointer-events-auto flex w-full max-w-sm items-start gap-3 rounded-xl border px-3.5 py-3 shadow-[0_8px_30px_rgba(15,23,42,0.12)] backdrop-blur-sm sm:max-w-md"
    [class]="visual(toast).containerClass"
    role="status"
  >
    <ion-icon
      [name]="visual(toast).icon"
      class="toast-host__icon mt-0.5 shrink-0 text-xl"
      [class]="visual(toast).iconClass"
      aria-hidden="true"
    ></ion-icon>

    <div class="min-w-0 flex-1">
      @if (toast.title) {
      <p class="text-sm font-semibold leading-snug" [class]="visual(toast).titleClass">
        {{ toast.title }}
      </p>
      }
      <p class="text-sm leading-snug text-gray-700" [class.mt-0.5]="toast.title">
        {{ toast.message }}
      </p>
    </div>

    @if (toast.dismissible) {
    <button
      type="button"
      class="m-0 inline-flex h-7 w-7 shrink-0 appearance-none items-center justify-center rounded-full text-gray-400 transition hover:bg-black/5 hover:text-gray-600"
      [attr.aria-label]="'Dismiss notification'"
      (click)="dismiss(toast.id)"
    >
      <ion-icon name="close-outline" class="text-lg" aria-hidden="true"></ion-icon>
    </button>
    }
  </article>
  }
</div>
